import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ICareerApiResponse } from '../../types/api/careerApi';
import { getCareerDataService } from '../../api/careerApi';
import { ICareerState } from '../../types/features/careerSlice';


export const getCareerData = createAsyncThunk<ICareerApiResponse>(
    'career/getCareerData',
    async () => {
        const response = await getCareerDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const careerSlice = createSlice({
    name: 'career',
    initialState: {
        careerLoader: false,
        status: false,
        msg: '',
        career_data: []
    } as ICareerState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCareerData.pending, (state) => {
                state.careerLoader = true;
            })
            .addCase(getCareerData.fulfilled, (state, action: PayloadAction<ICareerApiResponse>) => {
                state.career_data = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.careerLoader = false;
            })
            .addCase(getCareerData.rejected, (state, action) => {
                state.careerLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

    }
});

export default careerSlice.reducer;
